const BatteryDataColumnArray = [
  undefined,
  'all',
  'time',
  'dcb_address',
  'FCC',
  'RC',
  'SOC',
  'SOH',
  'cycleCount',
  'current',
  'moduleTotalVoltage',
  'numberOfSensor',
  'dCellTemperature1',
  'dCellTemperature2',
  'dCellTemperature3',
  'dCellTemperature4',
  'dCellTemperature5',
  'dCellTemperature6',
  'dCellTemperature7',
  'dCellTemperature8',
  'NumberOfSeriesCell',
  'dBlockVoltage1',
  'dBlockVoltage2',
  'dBlockVoltage3',
  'dBlockVoltage4',
  'dBlockVoltage5',
  'dBlockVoltage6',
  'dBlockVoltage7',
  'dBlockVoltage8',
  'dBlockVoltage9',
  'dBlockVoltage10',
  'dBlockVoltage11',
  'dBlockVoltage12',
  'dBlockVoltage13',
] as const

const BatterydataExLGColumnArray = [
  undefined,
  'all',
  'time',
  'MaxChargeVoltage',
  'MaxChargeCurrent',
  'EDV',
  'MaxDischargeCurrent',
  'FCC',
  'RC',
  'SOC',
  'SOH',
  'cycleCount',
  'DCB_TV',
  'MaxTerminalVoltage',
  'CV_Min',
  'CV_Max',
  'Current',
  'cellTemperatureMin',
  'CellTemperatureMax',
  'StatusByte',
  'Error',
  'MaxChargeCurrentPeak',
  'MaxDischargeCurrentPeak',
  'DcbCurrentMin',
  'DcbCurrentMax',
  'ErrorDcbList',
  'BpmTemp',
  'BpmStatus',
  'ControlCode',
  'InternalState',
  'BatPowerIn',
  'BatPowerOut',
  'BatCurrentIn',
  'BatCurrentOut',
  'ASOC',
] as const

const DcbdataColumnArray = [
  undefined,
  'all',
  'time',
  'module_index',
  'packVoltageAVG',
  'packVoltageMax',
  'packVoltageMin',
  'maxCellVoltageAVG',
  'maxCellVoltageMax',
  'maxCellVoltageMin',
  'minCellVoltageAVG',
  'minCellVoltageMax',
  'minCellVoltageMin',
  'currentAVG',
  'currentMax',
  'currentMin',
  'temperature1AVG',
  'temperature1Max',
  'temperature1Min',
  'temperature2AVG',
  'temperature2Max',
  'temperature2Min',
  'SOCAVG',
  'SOCMax',
  'SOCMin',
  'SOH',
  'maxChargeCurrentAVG',
  'maxChargeCurrentMax',
  'maxChargeCurrentMin',
  'maxDischargeCurrentAVG',
  'maxDischargeCurrentMax',
  'maxDischargeCurrentMin',
  'alarm',
  'warning',
  'fault',
  'fault2',
  'cycleCount',
  'accumulatedChargeEnergy',
  'accumulatedDischargeEnergy',
  'accumulatedChargeCurrent',
  'accumulatedDischargeCurrent',
  'accumulatedSOC',
  'FCC',
  'RC',
] as const

const DcbconfigurationColumnArray = [
  undefined,
  'all',
  'time',
  'tcManufacurerName',
  'tcDeviceName',
  'iNumberOfSeriesDCB',
  'iNumberOfParallelDCB',
  'dDesignCapacity',
  'dDesignVoltage',
  'iChargeHighTemperature',
  'iChargeLowTemperature',
  'iManufactureDate',
  'iSerialNumber',
  'iProtocolVersion',
  'iFWVersion',
  'iDataTableVersion',
  'iPCBversion',
  'bat_index',
] as const

const BatteryconfigurationColumnArray = [
  undefined,
  'all',
  'time',
  'DCBAddr',
  'tcManufacurerName',
  'tcDeviceName',
  'iNumberOfSeriesCell',
  'iNumberOfParallelCell',
  'dDesignCapacity',
  'dDesignVoltage',
  'iChargeHighTemperature',
  'iChargeLowTemperature',
  'iManufactureDate',
  'iSerialNumber',
  'iProtocolVersion',
  'iFWVersion',
  'iDataTableVersion',
  'iPCBversion',
  'tcSerialCode',
  'bat_index',
] as const

export type BatteryDataColumn = (typeof BatteryDataColumnArray)[number]
export type BatterydataExLGColumn = (typeof BatterydataExLGColumnArray)[number]
export type DcbdataColumn = (typeof DcbdataColumnArray)[number]
export type DcbconfigurationColumn = (typeof DcbconfigurationColumnArray)[number]
export type BatteryconfigurationColumn = (typeof BatteryconfigurationColumnArray)[number]

type tableOption = { value: string; label: string }

const batteryDataOption: tableOption[] = BatteryDataColumnArray.reduce((prev: tableOption[], curr) => {
  if (curr === 'all') {
    return [...prev, { value: curr, label: `${curr} columns` }]
  } else if (curr !== undefined) {
    return [...prev, { value: curr, label: curr }]
  } else {
    return [...prev]
  }
}, [])
const batterydataExLGOption: tableOption[] = BatterydataExLGColumnArray.reduce((prev: tableOption[], curr) => {
  if (curr === 'all') {
    return [...prev, { value: curr, label: `${curr} columns` }]
  } else if (curr !== undefined) {
    return [...prev, { value: curr, label: curr }]
  } else {
    return [...prev]
  }
}, [])
const dcbdataOption: tableOption[] = DcbdataColumnArray.reduce((prev: tableOption[], curr) => {
  if (curr === 'all') {
    return [...prev, { value: curr, label: `${curr} columns` }]
  } else if (curr !== undefined) {
    return [...prev, { value: curr, label: curr }]
  } else {
    return [...prev]
  }
}, [])
const dcbconfigurationOption: tableOption[] = DcbconfigurationColumnArray.reduce((prev: tableOption[], curr) => {
  if (curr === 'all') {
    return [...prev, { value: curr, label: `${curr} columns` }]
  } else if (curr !== undefined) {
    return [...prev, { value: curr, label: curr }]
  } else {
    return [...prev]
  }
}, [])
const batteryconfigurationOption: tableOption[] = BatteryconfigurationColumnArray.reduce((prev: tableOption[], curr) => {
  if (curr === 'all') {
    return [...prev, { value: curr, label: `${curr} columns` }]
  } else if (curr !== undefined) {
    return [...prev, { value: curr, label: curr }]
  } else {
    return [...prev]
  }
}, [])

export const tableColumnsOptions: tableOption[][] = [
  batteryDataOption,
  batterydataExLGOption,
  dcbdataOption,
  dcbconfigurationOption,
  batteryconfigurationOption,
]

export type TableName = 'batterydata' | 'batterydataExLG' | 'dcbdata' | 'dcbconfiguration' | 'batteryconfiguration'

export const getAllTableColumns = (table: TableName): ColumnType[] => {
  switch (table) {
    case 'batterydata':
      return BatteryDataColumnArray.filter(column => column !== 'all' && column !== undefined)
    case 'batterydataExLG':
      return BatterydataExLGColumnArray.filter(column => column !== 'all' && column !== undefined)
    case 'dcbdata':
      return DcbdataColumnArray.filter(column => column !== 'all' && column !== undefined)
    case 'dcbconfiguration':
      return DcbconfigurationColumnArray.filter(column => column !== 'all' && column !== undefined)
    case 'batteryconfiguration':
      return BatteryconfigurationColumnArray.filter(column => column !== 'all' && column !== undefined)
    default:
      return []
  }
}

export type ColumnType = BatteryDataColumn | BatterydataExLGColumn | DcbdataColumn | DcbconfigurationColumn | BatteryconfigurationColumn
export interface TableColumnsOption {
  value: ColumnType
  label: ColumnType
}

/**
 * Battery data can be exported
 * An export includes:
 * @param email emails to which the data are send
 * @param tables tables from which data are exported
 * @param jobs jobs which specify the relvant battery and it's history
 */
export interface BatteryExportModule {
  emails?: string[]
  tables?: BatteryTables
  jobs?: BatteryJob[]
}

export interface BatteryTables {
  batterydata?: {
    columns: BatteryDataColumn[]
    isSelected?: boolean
  }
  batterydataExLG?: {
    columns: BatterydataExLGColumn[]
    isSelected?: boolean
  }
  dcbdata?: {
    columns: DcbdataColumn[]
    isSelected?: boolean
  }
  dcbconfiguration?: {
    columns: DcbconfigurationColumn[]
    isSelected?: boolean
  }
  batteryconfiguration?: {
    columns: BatteryconfigurationColumn[]
    isSelected?: boolean
  }
}

export interface BatteryJob {
  type: BatteryType
  id: number
  from: number
  to: number
  dcb_history?: DcbhistoryModule[]
}

export enum BatteryType {
  SN = 'sn',
  TC = 'tc',
}

export interface DcbhistoryModule {
  serialno?: number
  tcSerialCode?: string
  bat_index?: number
  DCBAddr?: number
  from?: number
  to?: number
}
